import { ref, isRef, unref, watch } from 'vue';
import { tryOnScopeDispose } from '../tryOnScopeDispose';

const isClient = process.env.CLIENT
export function useInterval(fn, interval, immediate = true) {
  let timer = null;
  const isActive = ref(false);
  function clean() {
    if (timer) {
      clearInterval(timer);
      timer = null
    }
  }
  function resume() {
    const _fn = unref(fn);
    if (interval <= 0) return;
    isActive.value = true;
    clean();
    timer = setTimeout(async () => {
      if (!_fn) return;
      const result = _fn();
      if (result instanceof Promise) {
        result.finally(() => timer && resume());
      } else {
        timer && resume();
      }
    }, interval);
  }
  function pause() {
    clean();
    isActive.value = false;
  }

  if (immediate && isClient) {
    unref(fn)?.();
    resume();
  }
  if (isRef(fn)) {
    const stopWatchFn = watch(fn, () => {
      if (isActive.value && isClient) {
        unref(fn)?.();
        resume();
      }
    })
    tryOnScopeDispose(stopWatchFn);
  }

  tryOnScopeDispose(pause);
  return { isActive, pause, resume }
}
